// extracted by mini-css-extract-plugin
export default {"viewed":"MarkAsViewedButton-module__viewed--W1yv9"};